import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SupportRequestFormData } from '../schemas/supportRequestFormSchema';
import styles from './UserComments.module.css';

const UserComments = () => {
  const { t } = useTranslation();
  const { watch, setValue, formState: { errors } } = useFormContext<SupportRequestFormData>();
  const userComments = watch('userComments') || '';
  const goalWithLimits = watch('goalWithLimits');
  const isUnusualExpense = goalWithLimits?.goal?.name === 'UnusualExpense';

  return (
    <div className="w-full max-w-[832px] px-4">
      <h2 className="body-lr-bold text-(--font-sub-title-2)">
        {t('beforeSubmittingQuestion')}
      </h2>

      <label className="body-sm-regular text-(--font-heading) block mt-4 mb-1.5">
        {t('addComments')}
        {isUnusualExpense && <span className="text-red-500"> *</span>}
      </label>

      <textarea
        className={`body-md-regular text-(--font-body-1) ${styles.textarea} ${errors.userComments ? 'border-red-500' : ''}`}
        rows={6}
        placeholder={t('thisIsThePlaceToDetailSpecialRequestsOrAnyInformationThatWouldBeRelevantToUsInReviewingTheRequest')}
        value={userComments}
        onChange={(e) => setValue('userComments', e.target.value)}
      />
      {errors.userComments && (
        <p className="text-red-500 text-sm mt-1">{errors.userComments.message}</p>
      )}
    </div>
  );
};

export default UserComments;

